import React, {FC} from "react"

import Icon from "@irati/ui/src/Icon"

import {IconWrapper} from "./styled"

interface Props {
  icon: string
}

const TemplateIcon: FC<Props> = ({icon}) => (
  <IconWrapper>
    <Icon icon={icon} size="26" />
  </IconWrapper>
)

export default TemplateIcon
